module.exports = __webpack_public_path__ + "static/kids-playing.864c311a.jpg";